export async function connectGoogleSearchConsoleOAuthIntegration(): Promise<boolean> {
  try {
    // Start OAuth flow using the shared Google OAuth endpoint with provider parameter
    const authUrl = `${process.env.NEXT_PUBLIC_BACKEND_API_ENDPOINT_URI}/v2/oauth/google/authorize?provider=googleSearchConsole`

    return new Promise<boolean>((resolve) => {
      const popup = window.open(
        authUrl,
        'google-search-console-oauth',
        'width=500,height=600,scrollbars=yes,resizable=yes'
      )

      if (!popup) {
        resolve(false)
        return
      }

      const checkClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkClosed)
          channel.close()
          resolve(false)
        }
      }, 1000)

      // Listen for OAuth completion message via BroadcastChannel
      const channel = new BroadcastChannel('oauth_channel')
      channel.onmessage = (event) => {
        // Only handle Google Search Console OAuth messages
        if (
          !event.data ||
          !event.data.type ||
          !event.data.type.startsWith('GOOGLE_SEARCH_CONSOLE_OAUTH_')
        ) {
          return
        }

        if (event.data.type === 'GOOGLE_SEARCH_CONSOLE_OAUTH_SUCCESS') {
          clearInterval(checkClosed)
          popup.close()
          channel.close()
          resolve(true)
        } else if (event.data.type === 'GOOGLE_SEARCH_CONSOLE_OAUTH_ERROR') {
          clearInterval(checkClosed)
          popup.close()
          channel.close()
          resolve(false)
        }
      }
    })
  } catch (error) {
    console.error('Google Search Console OAuth connection error:', error)
    return false
  }
}
